<template>
  <v-card flat color="white">
    <v-card-text class="pa-6">

      <!-- Estado del Número de Plan -->
      <v-card outlined class="mb-4">
        <v-card-text class="pa-4">
          <v-row>
            <v-col cols="12" md="8">
              <v-chip
                v-if="planNumber"
                color="success"
                outlined
              >
                <v-icon left>mdi-check-circle</v-icon>
                Número de Plan: {{ planNumber }}
              </v-chip>
              <v-chip
                v-else
                color="error"
                outlined
              >
                <v-icon left>mdi-alert</v-icon>
                No hay número de plan configurado
              </v-chip>
              <v-chip
                v-if="bankAccountNumber"
                color="primary"
                outlined
                class="ml-2"
              >
                <v-icon left>mdi-bank</v-icon>
                Cuenta contable de banco: {{ bankAccountNumber }}
              </v-chip>
              <v-chip
                v-else
                color="warning"
                outlined
                class="ml-2"
              >
                <v-icon left>mdi-bank-off</v-icon>
                No hay cuenta de banco configurada
              </v-chip>
            </v-col>
            <v-col cols="12" md="2">
              <v-btn
                color="info"
                outlined
                @click="showPlanNumberDialog = true"
                block
              >
                <v-icon left>mdi-cog</v-icon>
                Configurar Plan
              </v-btn>
            </v-col>
            <v-col cols="12" md="2">
              <v-btn
                color="primary"
                outlined
                @click="openBankAccountDialog"
                block
              >
                <v-icon left>mdi-bank-plus</v-icon>
                Configurar Banco
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <!-- Filtros de búsqueda -->
      <v-card outlined class="mb-4">
        <v-card-text class="pa-5">
          <v-row>
            <v-col cols="12" class="mb-4">
              <b>Filtros de búsqueda de comprobantes</b>
            </v-col>
            <v-col cols="12" md="2">
              <v-menu
                v-model="menuStartDate"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="filters.startDate"
                    label="Fecha Inicial"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    dense
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="filters.startDate"
                  @input="menuStartDate = false"
                  locale="es"
                ></v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="12" md="2">
              <v-menu
                v-model="menuEndDate"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="filters.endDate"
                    label="Fecha Final"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    dense
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="filters.endDate"
                  @input="menuEndDate = false"
                  locale="es"
                ></v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="12" md="3">
              <v-select
                v-model="filters.invoiceStatus"
                :items="statusOptions"
                label="Estado de Factura"
                outlined
                dense
              ></v-select>
            </v-col>

            <v-col cols="12" md="3">
              <v-select
                v-model="filters.invoiceType"
                :items="invoiceTypeOptions"
                label="Tipo de Factura"
                item-text="text"
                item-value="value"
                clearable
                outlined
                dense
              ></v-select>
            </v-col>
            <v-col cols="12" md="2">
              <v-btn
                color="primary"
                @click="loadPayments"
                :loading="loading"
                block
              >
                <v-icon left>mdi-magnify</v-icon>
                Buscar
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <!-- Información de plantilla -->
      <v-card outlined class="mb-4" v-if="searched">
        <v-card-text class="pa-5">
          <v-row>
            <v-col cols="12" class="mb-4">
              <b>{{ isEditMode ? 'Edición de plantilla de pagos' : 'Creación de plantilla de pagos' }}</b>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                v-model="templateName"
                label="Nombre de la Plantilla"
                outlined
                dense
                hint=""
                persistent-hint
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                v-model="templateDescription"
                label="Descripción de la Plantilla"
                outlined
                dense
                hint=""
                persistent-hint
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-menu
                v-model="menuTemplateDate"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="templateDate"
                    label="Fecha de Plantilla"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    dense
                    hint="Fecha de la transaccion"
                    persistent-hint
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="templateDate"
                  @input="menuTemplateDate = false"
                  locale="es"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                v-model="sendNumber"
                label="Número de Envío"
                type="text"
                outlined
                dense
                @keypress="onlyNumbers"
                @blur="formatSendNumber"
                maxlength="5"
                :rules="sendNumberRules"
                hint="5 dígitos (ej: 00001)"
                persistent-hint
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <!-- ===== PASO 1: SELECCIÓN DE PAGOS ===== -->
      <template v-if="currentStep === 1">

        <!-- Indicador de pasos -->
        <div class="d-flex align-center mb-4" v-if="payments.length > 0">
          <div class="d-flex align-center step-indicator">
            <v-avatar size="30" color="primary" class="mr-2">
              <span class="white--text caption font-weight-bold">1</span>
            </v-avatar>
            <span class="font-weight-medium primary--text">Seleccionar Pagos</span>
          </div>

          <v-divider class="mx-4" style="max-width: 60px;"></v-divider>

          <div class="d-flex align-center step-indicator">
            <v-avatar size="30" color="grey lighten-1" class="mr-2">
              <span class="white--text caption font-weight-bold">2</span>
            </v-avatar>
            <span class="font-weight-medium grey--text">Revisar y Confirmar</span>
          </div>
        </div>

        <!-- Tabla de pagos -->
        <v-data-table
          v-if="payments.length > 0"
          v-model="selectedPayments"
          :headers="headers"
          :items="filteredPayments"
          :loading="loading"
          show-select
          item-key="IDPurchaseOrExpenses"
          class="elevation-1 mt-4"
          :items-per-page="10"
          :footer-props="{
            'items-per-page-options': [5, 10, 15, 20, 50, 100]
          }"
          :item-class="getRowClass"
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>Pagos Disponibles</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-chip class="ma-2" color="primary" outlined>
                Total: {{ filteredPayments.length }}
              </v-chip>
              <v-chip class="ma-2" color="success" outlined>
                Seleccionados: {{ selectedPayments.length }}
              </v-chip>
            </v-toolbar>
            <v-divider></v-divider>
            <div class="pa-3">
              <v-text-field
                v-model="providerFilter"
                label="Buscar por proveedor"
                prepend-inner-icon="mdi-magnify"
                outlined
                dense
                hide-details
                clearable
              ></v-text-field>
            </div>
          </template>

          <template v-slot:[`header.data-table-select`]>
            <v-simple-checkbox
              :value="allValidPaymentsSelected"
              @input="toggleSelectAll"
              :indeterminate="someValidPaymentsSelected && !allValidPaymentsSelected"
              :ripple="false"
            ></v-simple-checkbox>
          </template>

          <template v-slot:[`item.data-table-select`]="{ item, isSelected, select }">
            <v-simple-checkbox
              :value="isSelected"
              @input="select($event)"
              :disabled="!isPaymentValid(item)"
              :ripple="false"
            ></v-simple-checkbox>
          </template>

          <template v-slot:[`item.validationStatus`]="{ item }">
            <div class="d-flex align-center">
              <v-tooltip bottom v-if="!isPaymentValid(item)">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon color="error" v-bind="attrs" v-on="on">
                    mdi-alert-circle
                  </v-icon>
                </template>
                <span>{{ getValidationMessage(item) }}</span>
              </v-tooltip>
              <v-icon v-else color="success">
                mdi-check-circle
              </v-icon>

              <v-tooltip top v-if="needsProviderBankEdit(item)" class="ml-2">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    small
                    color="warning"
                    v-bind="attrs"
                    v-on="on"
                    @click="openProviderBankEditDialog(item)"
                  >
                    <v-icon small>mdi-pencil</v-icon>
                  </v-btn>
                </template>
                <span>Completar banco del proveedor</span>
              </v-tooltip>
            </div>
          </template>

          <template v-slot:[`item.FormattedDate`]="{ item }">
            {{ formatDate(item.FormattedDate) }}
          </template>

          <template v-slot:[`item.TotalCompra`]="{ item }">
            ${{ parseFloat(item.pendiente_pago || 0).toFixed(2) }}
          </template>

          <template v-slot:[`item.PartialAmount`]="{ item }">
            <v-text-field
              v-model.number="item.PartialAmount"
              type="number"
              step="0.01"
              dense
              outlined
              hide-details
              prefix="$"
              @input="updateBalance(item)"
              :disabled="!isSelected(item)"
              style="max-width: 130px;"
            ></v-text-field>
          </template>

          <template v-slot:[`item.Balance`]="{ item }">
            <span :class="getBalanceClass(item)">
              ${{ calculateBalance(item).toFixed(2) }}
            </span>
          </template>

          <template v-slot:[`item.TypeDocument`]="{ item }">
            <v-chip small :color="getDocumentColor(item.TypeDocument)">
              {{ item.TypeDocument }}
            </v-chip>
          </template>

        </v-data-table>

        <!-- Botón Revisar -->
        <v-row v-if="selectedPayments.length > 0" class="mt-4">
          <v-col cols="12">
            <!-- Resumen de totales paso 1 -->
            <v-card outlined>
              <v-card-text class="pa-4">
                <v-row>
                  <v-col cols="12" md="3">
                    <div class="text-subtitle-2 grey--text">Total Pendiente</div>
                    <div class="text-h6">${{ getTotalOriginal().toFixed(2) }}</div>
                  </v-col>
                  <v-col cols="12" md="3">
                    <div class="text-subtitle-2 grey--text">Total a Pagar (PNR)</div>
                    <div class="text-h6 success--text">${{ getTotalPartial().toFixed(2) }}</div>
                  </v-col>
                  <v-col cols="12" md="3">
                    <div class="text-subtitle-2 grey--text">Saldo Pendiente</div>
                    <div class="text-h6 orange--text">${{ getTotalBalance().toFixed(2) }}</div>
                  </v-col>
                  <v-col cols="12" md="3">
                    <div class="text-subtitle-2 grey--text">Transacciones</div>
                    <div class="text-h6">{{ selectedPayments.length }}</div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" class="d-flex justify-end mt-2">
            <v-btn
              color="primary"
              @click="goToReview"
              large
            >
              <v-icon left>mdi-arrow-right-circle</v-icon>
              Revisar ({{ selectedPayments.length }} pago{{ selectedPayments.length !== 1 ? 's' : '' }})
            </v-btn>
          </v-col>
        </v-row>

        <!-- Mensaje cuando no hay datos -->
        <v-alert
          v-if="!loading && payments.length === 0 && searched"
          type="info"
          outlined
          class="mt-4"
        >
          No se encontraron pagos para los filtros seleccionados.
        </v-alert>

      </template>
      <!-- ===== FIN PASO 1 ===== -->

      <!-- ===== PASO 2: REVISIÓN Y CONFIRMACIÓN ===== -->
      <template v-if="currentStep === 2">

        <!-- Indicador de pasos -->
        <div class="d-flex align-center mb-4">
          <div class="d-flex align-center step-indicator">
            <v-avatar size="30" color="success" class="mr-2">
              <v-icon small color="white">mdi-check</v-icon>
            </v-avatar>
            <span class="font-weight-medium success--text">Seleccionar Pagos</span>
          </div>

          <v-divider class="mx-4" style="max-width: 60px;"></v-divider>

          <div class="d-flex align-center step-indicator">
            <v-avatar size="30" color="primary" class="mr-2">
              <span class="white--text caption font-weight-bold">2</span>
            </v-avatar>
            <span class="font-weight-medium primary--text">Revisar y Confirmar</span>
          </div>
        </div>

        <!-- Tabla de pagos seleccionados (solo lectura de selección) -->
        <v-data-table
          :headers="reviewHeaders"
          :items="selectedPayments"
          item-key="IDPurchaseOrExpenses"
          class="elevation-1"
          :items-per-page="10"
          :footer-props="{
            'items-per-page-options': [5, 10, 15, 20, 50, 100]
          }"
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>Pagos Seleccionados</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-chip class="ma-2" color="primary" outlined>
                Total: {{ selectedPayments.length }}
              </v-chip>
            </v-toolbar>
          </template>

          <template v-slot:[`item.validationStatus`]>
            <v-icon color="success">mdi-check-circle</v-icon>
          </template>

          <template v-slot:[`item.FormattedDate`]="{ item }">
            {{ formatDate(item.FormattedDate) }}
          </template>

          <template v-slot:[`item.TotalCompra`]="{ item }">
            ${{ parseFloat(item.pendiente_pago || 0).toFixed(2) }}
          </template>

          <template v-slot:[`item.PartialAmount`]="{ item }">
            <v-text-field
              v-model.number="item.PartialAmount"
              type="number"
              step="0.01"
              dense
              outlined
              hide-details
              prefix="$"
              @input="updateBalance(item)"
              style="max-width: 130px;"
            ></v-text-field>
          </template>

          <template v-slot:[`item.Balance`]="{ item }">
            <span :class="getBalanceClass(item)">
              ${{ calculateBalance(item).toFixed(2) }}
            </span>
          </template>

          <template v-slot:[`item.TypeDocument`]="{ item }">
            <v-chip small :color="getDocumentColor(item.TypeDocument)">
              {{ item.TypeDocument }}
            </v-chip>
          </template>

          <template v-slot:[`item.actions`]="{ item }">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  small
                  color="error"
                  v-bind="attrs"
                  v-on="on"
                  @click="removeSelectedPayment(item)"
                >
                  <v-icon small>mdi-delete</v-icon>
                </v-btn>
              </template>
              <span>Eliminar pago de la plantilla</span>
            </v-tooltip>
          </template>
        </v-data-table>

        <!-- Resumen de totales -->
        <v-card outlined class="mt-4">
          <v-card-text class="pa-4">
            <v-row>
              <v-col cols="12" md="3">
                <div class="text-subtitle-2 grey--text">Total Pendiente</div>
                <div class="text-h6">${{ getTotalOriginal().toFixed(2) }}</div>
              </v-col>
              <v-col cols="12" md="3">
                <div class="text-subtitle-2 grey--text">Total a Pagar (PNR)</div>
                <div class="text-h6 success--text">${{ getTotalPartial().toFixed(2) }}</div>
              </v-col>
              <v-col cols="12" md="3">
                <div class="text-subtitle-2 grey--text">Saldo Pendiente</div>
                <div class="text-h6 orange--text">${{ getTotalBalance().toFixed(2) }}</div>
              </v-col>
              <v-col cols="12" md="3">
                <div class="text-subtitle-2 grey--text">Transacciones</div>
                <div class="text-h6">{{ selectedPayments.length }}</div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <!-- Acciones paso 2 -->
        <v-row class="mt-4">
          <v-col cols="12" class="d-flex justify-space-between">
            <v-btn
              color="secondary"
              outlined
              @click="goBack"
              large
            >
              <v-icon left>mdi-arrow-left-circle</v-icon>
              Volver a Selección
            </v-btn>
            <v-btn
              color="success"
              @click="createTemplate"
              :loading="saving"
              large
            >
              <v-icon left>mdi-content-save</v-icon>
              {{ isEditMode ? 'Actualizar Plantilla' : 'Crear Plantilla' }}
            </v-btn>
            <v-btn
              v-if="isEditMode"
              color="secondary"
              outlined
              class="ml-3"
              @click="cancelEdit"
              large
            >
              <v-icon left>mdi-close-circle</v-icon>
              Cancelar Edición
            </v-btn>
          </v-col>
        </v-row>

      </template>
      <!-- ===== FIN PASO 2 ===== -->

    </v-card-text>

    <!-- Alert -->
    <alerts
      v-if="alert.show"
      v-on:close_alert="closeAlert"
      v-on:accept_alert="acceptAlert"
      :properties="alert"
    ></alerts>
    
    <!-- Componente para configurar número de plan -->
    <ManageAccountingReport 
      v-if="showPlanNumberDialog"
      :businessData="{ ID_Business: ID_Business }"
      :autoOpen="true"
      :showPlan="true"
      @configuration-updated="onPlanNumberUpdated"
      @dialog-closed="showPlanNumberDialog = false"
    />
    
    <v-dialog
      v-model="showBankAccountDialog"
      max-width="1150"
      persistent
    >
      <v-card>
        <v-card-title class="d-flex justify-space-between align-center">
          <span>Seleccionar cuenta de banco</span>
          <v-btn icon @click="closeBankAccountDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pt-0">
          <AccountingItemForm
            :isAllowTransaction="false"
            @sendSelection="onBankAccountSelected"
            @closeDialog="closeBankAccountDialog"
          />
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="showProviderBankDialog"
      max-width="760"
      persistent
    >
      <v-card>
        <v-card-title class="d-flex justify-space-between align-center">
          <span>Editar banco del proveedor</span>
          <v-btn icon @click="closeProviderBankEditDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-alert v-if="providerBankEditLoading" type="info" outlined>
            Cargando información del proveedor...
          </v-alert>

          <template v-else>
            <v-row>
              <v-col cols="12" class="mb-2">
                <div class="text-subtitle-2 grey--text">Nombre legal</div>
                <div class="text-body-1">{{ providerBankEdit.ProviderLegalName || 'N/A' }}</div>
              </v-col>
              <v-col cols="12" md="4">
                <div class="text-subtitle-2 grey--text">ID proveedor</div>
                <div class="text-body-1">{{ providerBankEdit.ID_Provider || 'N/A' }}</div>
              </v-col>
              <v-col cols="12" md="4">
                <div class="text-subtitle-2 grey--text">Tipo proveedor</div>
                <v-chip small :color="providerTypeColor(providerBankEdit.TypeProvider)" outlined>
                  {{ providerTypeLabel(providerBankEdit.TypeProvider) }}
                </v-chip>
              </v-col>
              <v-col cols="12" md="4">
                <div class="text-subtitle-2 grey--text">NIT</div>
                <div class="text-body-1">{{ providerBankEdit.ProviderLegalNIT || 'N/A' }}</div>
              </v-col>
            </v-row>

            <v-divider class="my-4"></v-divider>

            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="providerBankEdit.ProviderBank"
                  outlined
                  dense
                  label="Código del banco"
                  hint="Código del banco este depende del banco al que corresponde la cuenta bancaria Ej. 22"
                  persistent-hint
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="providerBankEdit.ProviderBankAccount"
                  outlined
                  dense
                  label="Número de cuenta bancaria"
                  hint="Número de cuenta bancaria del proveedor"
                  persistent-hint
                ></v-text-field>
              </v-col>
            </v-row>
          </template>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn outlined @click="closeProviderBankEditDialog">Cancelar</v-btn>
          <v-btn
            color="primary"
            :loading="providerBankEditSaving"
            @click="saveProviderBankEdit"
          >
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import alerts from '@/components/Alerts.vue';
import ManageAccountingReport from '@/views/settings/business/partial/ManageAccountingReport.vue';
import AccountingItemForm from '@/views/acounting/partial/AccountingItemForm.vue';

export default {
  name: 'CreatePaymentTemplate',
  components: {
    alerts,
    ManageAccountingReport,
    AccountingItemForm
  },
  props: {
    win: {
      type: Object,
      required: false,
      default: null
    },
    initialTemplateId: {
      type: [String, Number],
      required: false,
      default: null
    }
  },
  data() {
    // Calcular fechas por defecto
    const today = new Date();
    const oneMonthAgo = new Date();
    oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);
    
    // Generar nombre por defecto para la plantilla
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const defaultTemplateName = `Plantilla para pagos ${year}/${month}`;
    
    return {
      loading: false,
      saving: false,
      searched: false,
      menuStartDate: false,
      menuEndDate: false,
      menuTemplateDate: false,
      filters: {
        startDate: oneMonthAgo.toISOString().split('T')[0],
        endDate: today.toISOString().split('T')[0],
        invoiceStatus: 'all',
        invoiceType: null
      },
      statusOptions: [
        { text: 'Todas', value: 'all' },
        { text: 'Pendiente de pago', value: 'Pendiente de pago' },
        { text: 'Cancelada', value: 'Cancelada' },
        { text: 'Crédito', value: 'Crédito' }
      ],
      invoiceTypeOptions: [
        { value: 'FCF', text: 'CONSUMIDOR FINAL' },
        { value: 'CCF', text: 'CRÉDITO FISCAL' },
        { value: 'FNS', text: 'SUJETO EXCLUIDO' },
        { value: 'FEX', text: 'EXPORTACIÓN' }
      ],
      templateName: defaultTemplateName,
      templateDescription: '',
      templateDate: today.toISOString().split('T')[0],
      sendNumber: '',
      sendNumberRules: [
        v => !!v || 'El número de envío es requerido',
        v => /^\d{1,5}$/.test(v) || 'Debe contener solo números (máximo 5 dígitos)',
        v => v.length === 5 || 'Debe tener exactamente 5 dígitos'
      ],
      payments: [],
      selectedPayments: [],
      isEditMode: false,
      editingTemplateId: null,
      deletedDetailIds: [],
      headers: [
        { text: 'Estado', value: 'validationStatus', sortable: false, width: '80px' },
        { text: 'Tipo', value: 'TypeDocument', sortable: true, width: '100px' },
        { text: 'Fecha', value: 'FormattedDate', sortable: true, width: '120px' },
        { text: 'Número Documento', value: 'NÚMERO DE DOCUMENTO', sortable: true },
        { text: 'Proveedor', value: 'NOMBRE DEL PROVEEDOR', sortable: true },
        { text: 'Pendiente de Pago', value: 'TotalCompra', sortable: true, align: 'end', width: '130px' },
        { text: 'Monto a Pagar', value: 'PartialAmount', sortable: false, align: 'end', width: '150px' },
        { text: 'Saldo', value: 'Balance', sortable: false, align: 'end', width: '120px' }
      ],
      reviewHeaders: [
        { text: 'Estado', value: 'validationStatus', sortable: false, width: '80px' },
        { text: 'Tipo', value: 'TypeDocument', sortable: true, width: '100px' },
        { text: 'Fecha', value: 'FormattedDate', sortable: true, width: '120px' },
        { text: 'Número Documento', value: 'NÚMERO DE DOCUMENTO', sortable: true },
        { text: 'Proveedor', value: 'NOMBRE DEL PROVEEDOR', sortable: true },
        { text: 'Pendiente de Pago', value: 'TotalCompra', sortable: true, align: 'end', width: '130px' },
        { text: 'Monto a Pagar', value: 'PartialAmount', sortable: false, align: 'end', width: '150px' },
        { text: 'Saldo', value: 'Balance', sortable: false, align: 'end', width: '120px' },
        { text: 'Acciones', value: 'actions', sortable: false, align: 'center', width: '90px' }
      ],
      alert: {
        type: 'success',
        show: false,
        header: '',
        body: ''
      },
      showPlanNumberDialog: false,
      planNumber: null,
      showBankAccountDialog: false,
      bankAccountId: null,
      bankAccountNumber: null,
      showProviderBankDialog: false,
      providerBankEditLoading: false,
      providerBankEditSaving: false,
      providerBankEdit: {
        ID_Provider: null,
        ProviderName: '',
        ProviderLegalName: '',
        ProviderLegalNIT: '',
        ProviderBank: '',
        ProviderBankAccount: '',
        TypeProvider: null,
        business_provider: null,
        branch_provider: null
      },
      currentStep: 1,
      providerFilter: '',
      pendingTemplateAction: null
    };
  },
  computed: {
    ID_Business() {
      return JSON.parse(localStorage.getItem('user')).businessid || 0;
    },
    ID_Branch() {
      return JSON.parse(localStorage.getItem('user')).branch || 0;
    },
    validPayments() {
      return this.filteredPayments.filter(p => this.isPaymentValid(p));
    },
    allValidPaymentsSelected() {
      if (this.validPayments.length === 0) return false;
      return this.validPayments.every(p => 
        this.selectedPayments.some(sp => this.getPaymentKey(sp) === this.getPaymentKey(p))
      );
    },
    someValidPaymentsSelected() {
      return this.validPayments.some(p =>
        this.selectedPayments.some(sp => this.getPaymentKey(sp) === this.getPaymentKey(p))
      ) && !this.allValidPaymentsSelected;
    },
    filteredPayments() {
      if (!this.providerFilter || this.providerFilter.trim() === '') {
        return this.payments;
      }
      const search = this.providerFilter.trim().toLowerCase();
      return this.payments.filter(p =>
        (p['NOMBRE DEL PROVEEDOR'] || '').toLowerCase().includes(search)
      );
    }
  },
  async mounted() {
    await this.loadPlanNumber();
    await this.loadBankAccountConfig();

    if (this.initialTemplateId) {
      await this.loadTemplateForEdit(this.initialTemplateId);
    } else {
      await this.loadNextSendNumber();
    }
  },
  watch: {
    templateDate(newDate) {
      // Actualizar el nombre de la plantilla solo si sigue siendo el valor por defecto
      const currentName = this.templateName;
      const isDefaultName = currentName && currentName.startsWith('Plantilla para pagos');
      
      if (!currentName || isDefaultName) {
        this.templateName = this.generateDefaultTemplateName(new Date(newDate));
      }
    }
  },
  methods: {
    getPaymentKey(payment) {
      return String(payment?.IDPurchaseOrExpenses ?? '');
    },

    dedupePaymentsByKey(payments) {
      const map = new Map();
      for (const payment of payments || []) {
        const key = this.getPaymentKey(payment);
        if (!key) {
          continue;
        }
        map.set(key, payment);
      }
      return Array.from(map.values());
    },

    providerTypeLabel(typeProvider) {
      if (Number(typeProvider) === 1) {
        return 'Proveedor de gastos';
      }

      return 'Proveedor de inventario';
    },

    providerTypeColor(typeProvider) {
      return Number(typeProvider) === 1 ? 'deep-orange' : 'primary';
    },

    needsProviderBankEdit(item) {
      const hasText = value => value !== null && value !== undefined && String(value).trim() !== '';
      return (
        hasText(item?.ID_Provider) &&
        (!hasText(item?.ProviderBank) || !hasText(item?.ProviderBankAccount))
      );
    },

    closeProviderBankEditDialog() {
      this.showProviderBankDialog = false;
      this.providerBankEditLoading = false;
      this.providerBankEditSaving = false;
      this.providerBankEdit = {
        ID_Provider: null,
        ProviderName: '',
        ProviderLegalName: '',
        ProviderLegalNIT: '',
        ProviderBank: '',
        ProviderBankAccount: '',
        TypeProvider: null,
        business_provider: null,
        branch_provider: null
      };
    },

    syncProviderBankInPayments(updatedProvider) {
      const providerId = String(updatedProvider.ID_Provider);
      const patch = {
        ProviderBank: updatedProvider.ProviderBank || '',
        ProviderBankAccount: updatedProvider.ProviderBankAccount || '',
        TypeProvider: updatedProvider.TypeProvider !== undefined && updatedProvider.TypeProvider !== null
          ? Number(updatedProvider.TypeProvider)
          : null
      };

      this.selectedPayments = this.selectedPayments.map(payment => {
        if (String(payment.ID_Provider) !== providerId) {
          return payment;
        }

        return {
          ...payment,
          ...patch
        };
      });

      this.payments = this.payments.map(payment => {
        if (String(payment.ID_Provider) !== providerId) {
          return payment;
        }

        return {
          ...payment,
          ...patch
        };
      });
    },

    async openProviderBankEditDialog(item) {
      const providerId = item?.ID_Provider;
      if (!providerId) {
        this.showAlert('warning', 'Proveedor no disponible', 'No se pudo identificar el proveedor para editar sus cuentas bancarias.');
        return;
      }

      this.showProviderBankDialog = true;
      this.providerBankEditLoading = true;

      try {
        const response = await this.$API.providers.getSpecifiedProvider(providerId, {
          type_provider: item.TypeProvider != null ? Number(item.TypeProvider) : 0
        });

        this.providerBankEdit = {
          ID_Provider: response.ID_Provider || providerId,
          ProviderName: response.ProviderName || '',
          ProviderLegalName: response.ProviderLegalName || '',
          ProviderLegalNIT: response.ProviderLegalNIT || '',
          ProviderBank: response.ProviderBank || '',
          ProviderBankAccount: response.ProviderBankAccount || '',
          TypeProvider: response.TypeProvider !== undefined && response.TypeProvider !== null
            ? Number(response.TypeProvider)
            : (item.TypeProvider !== undefined && item.TypeProvider !== null ? Number(item.TypeProvider) : null),
          business_provider: response.ID_Business || this.ID_Business,
          branch_provider: response.ID_Branch || this.ID_Branch
        };
      } catch (error) {
        console.error('Error al cargar proveedor para edición bancaria:', error);
        this.closeProviderBankEditDialog();
        this.showAlert('danger', 'Error', 'No se pudo cargar la información del proveedor.');
      } finally {
        this.providerBankEditLoading = false;
      }
    },

    async saveProviderBankEdit() {
      if (!this.providerBankEdit.ID_Provider) {
        this.showAlert('warning', 'Proveedor no disponible', 'No se pudo identificar el proveedor para guardar los cambios.');
        return;
      }

      if (!String(this.providerBankEdit.ProviderBank || '').trim() || !String(this.providerBankEdit.ProviderBankAccount || '').trim()) {
        this.showAlert('warning', 'Datos requeridos', 'Debe completar ProviderBank y ProviderBankAccount.');
        return;
      }

      this.providerBankEditSaving = true;
      try {
        const payload = {
          providerbank: this.providerBankEdit.ProviderBank,
          providerbankaccount: this.providerBankEdit.ProviderBankAccount,
          idbusiness: this.providerBankEdit.business_provider,
          idbranch: this.providerBankEdit.branch_provider,
          business_provider: this.providerBankEdit.business_provider,
          branch_provider: this.providerBankEdit.branch_provider,
          id_provider: this.providerBankEdit.ID_Provider
        };

        await this.$API.providers.updateProvider(this.providerBankEdit.ID_Provider, payload);

        this.syncProviderBankInPayments(this.providerBankEdit);
        this.closeProviderBankEditDialog();
        this.showAlert('success', 'Éxito', 'Los datos bancarios del proveedor se actualizaron correctamente.');
      } catch (error) {
        console.error('Error al guardar banco del proveedor:', error);
        this.showAlert('danger', 'Error', 'No se pudo actualizar la información bancaria del proveedor.');
      } finally {
        this.providerBankEditSaving = false;
      }
    },

    goToReview() {
      this.currentStep = 2;
    },

    goBack() {
      this.currentStep = 1;
    },

    generateDefaultTemplateName(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      
      return `Plantilla para pagos ${year}-${month}`;
    },
    
    onlyNumbers(event) {
      // Permitir solo números (códigos de tecla 48-57 son 0-9)
      const charCode = event.which ? event.which : event.keyCode;
      if (charCode < 48 || charCode > 57) {
        event.preventDefault();
      }
    },
    
    formatSendNumber() {
      // Rellenar con ceros a la izquierda para tener siempre 5 dígitos
      if (this.sendNumber && this.sendNumber.length > 0) {
        this.sendNumber = this.sendNumber.padStart(5, '0');
      }
    },
    
    async loadNextSendNumber() {
      if (this.isEditMode) {
        return;
      }

      try {
        const response = await this.$API.paymenttemplate.getNextSendNumber();
        this.sendNumber = response.sendNumber;
      } catch (error) {
        console.error('Error al cargar número de envío:', error);
        // Si falla, dejar el campo vacío para que el usuario lo ingrese manualmente
      }
    },

    async loadTemplateForEdit(templateId) {
      try {
        this.loading = true;
        this.isEditMode = true;
        this.editingTemplateId = templateId;
        this.deletedDetailIds = [];
        this.providerFilter = '';

        const response = await this.$API.paymenttemplate.getTemplateById(templateId);
        const header = response?.header || null;
        const details = Array.isArray(response?.details) ? response.details : [];

        if (!header) {
          throw new Error('No se pudo cargar el encabezado de la plantilla');
        }

        this.planNumber = header.PlanNumber || this.planNumber;
        this.templateName = header.Name || '';
        this.templateDescription = header.Description || '';
        this.templateDate = header.Date ? String(header.Date).substring(0, 10) : this.templateDate;
        this.sendNumber = header.SendNumber != null ? String(header.SendNumber).padStart(5, '0') : '';
        this.selectedPayments = details.map(detail => ({
          ...detail,
          ID_PaymentTemplateDetail: detail.ID_PaymentTemplateDetail || detail.ID || null,
          IDPurchaseOrExpenses: detail.IDPurchaseOrExpenses || detail.ID_Payment,
          TypeDocument: detail.TypeDocument || null,
          'NÚMERO DE DOCUMENTO': detail['NÚMERO DE DOCUMENTO'] || detail.DocumentNumber || null,
          'NOMBRE DEL PROVEEDOR': detail['NOMBRE DEL PROVEEDOR'] || detail.ProviderName || null,
          pendiente_pago: parseFloat(detail.pendiente_pago || detail.TotalCompra || detail.Total || 0),
          TotalCompra: parseFloat(detail.TotalCompra || detail.Total || detail.pendiente_pago || 0),
          PartialAmount: detail.PartialAmount != null && detail.PartialAmount !== ''
            ? parseFloat(detail.PartialAmount)
            : parseFloat(detail.TotalCompra || detail.Total || detail.pendiente_pago || 0),
          FormattedDate: detail.FormattedDate || detail.PaymentDate || null,
          NumeroControl: detail.NumeroControl || null,
          InvoiceStatus: detail.InvoiceStatus || null,
          ID_Provider: detail.ID_Provider || detail.IDProviderOrCustomer || null,
          TypeProvider: detail.TypeProvider !== undefined && detail.TypeProvider !== null
            ? Number(detail.TypeProvider)
            : null,
          ProviderBank: detail.ProviderBank || null,
          ProviderBankAccount: detail.ProviderBankAccount || null,
          ProviderLegalNIT: detail.ProviderLegalNIT || null,
          _persisted: true
        }));
        this.selectedPayments = this.dedupePaymentsByKey(this.selectedPayments);
        this.payments = [];
        this.searched = true;
        this.currentStep = 2;
      } catch (error) {
        console.error('Error al cargar plantilla para edición:', error);
        this.showAlert('danger', 'Error', 'No se pudo cargar la plantilla seleccionada para edición.');
        this.isEditMode = false;
        this.editingTemplateId = null;
        this.selectedPayments = [];
        this.currentStep = 1;
        this.searched = false;
        await this.loadNextSendNumber();
      } finally {
        this.loading = false;
      }
    },
    
    async loadPlanNumber() {
      try {
        const userData = JSON.parse(localStorage.getItem('user'));
        this.planNumber = userData?.PlanNumber || null;
      } catch (error) {
        console.error('Error al cargar número de plan:', error);
        this.planNumber = null;
      }
    },
    
    onPlanNumberUpdated(data) {
      this.planNumber = data.PlanNumber;
      this.showPlanNumberDialog = false;
      this.showAlert('success', 'Éxito', 'Número de plan actualizado. Por favor cierre sesión para que los cambios surtan efecto.');
    },

    openBankAccountDialog() {
      this.showBankAccountDialog = true;
    },
    closeBankAccountDialog() {
      this.showBankAccountDialog = false;
    },
    async loadBankAccountConfig() {
      try {
        const [configResponse, catalogResponse] = await Promise.all([
          this.$API.branchaccountconfig.getBranchAccountsConfig(),
          this.$API.branchaccountcatalog.getActiveBranchAccountCatalog()
        ]);

        const configuredBankAccountId = configResponse?.data?.config?.bank_account_id_account || null;
        this.bankAccountId = configuredBankAccountId;

        if (!configuredBankAccountId) {
          this.bankAccountNumber = null;
          return;
        }

        const account = (catalogResponse?.data || []).find(
          item => Number(item.id_account) === Number(configuredBankAccountId)
        );

        this.bankAccountNumber = account?.account_code || null;
      } catch (error) {
        console.error('Error al cargar cuenta de banco:', error);
        this.bankAccountId = null;
        this.bankAccountNumber = null;
      }
    },
    async onBankAccountSelected(account) {
      try {
        const response = await this.$API.branchaccountconfig.updateBankAccountConfig({
          bank_account_id_account: account.id_account
        });

        if (!response.success) {
          throw new Error(response.error || 'No fue posible guardar la cuenta de banco');
        }

        this.bankAccountId = account.id_account;
        this.bankAccountNumber = account.account_code;
        this.closeBankAccountDialog();
        this.showAlert('success', 'Éxito', 'Cuenta de banco configurada correctamente.');
      } catch (error) {
        console.error('Error al guardar cuenta de banco:', error);
        this.showAlert('danger', 'Error', 'No se pudo guardar la cuenta de banco seleccionada.');
      }
    },
    closeAlert() {
      this.alert.show = false;
    },
    acceptAlert() {
      this.alert.show = false;
      if (this.pendingTemplateAction) {
        const action = this.pendingTemplateAction;
        this.pendingTemplateAction = null;
        this.resetForm();
        this.$emit(action === 'edit' ? 'template-updated' : 'template-created');
      }
    },
    showAlert(type, header, body, options = null) {
      type = type == null ? 'danger' : type;
      this.alert.type = type;
      this.alert.header = header;
      this.alert.body = body;
      this.alert.show = true;
      this.alert.options = options != null ? options : null;
    },
    isSelected(item) {
      const itemKey = this.getPaymentKey(item);
      return this.selectedPayments.some(p => this.getPaymentKey(p) === itemKey);
    },
    
    updateBalance(item) {
      // Asegurar que el monto parcial no sea mayor al pendiente
      const pendiente = parseFloat(item.pendiente_pago || 0);
      const partial = parseFloat(item.PartialAmount || 0);
      
      if (partial > pendiente) {
        item.PartialAmount = pendiente;
      }
      
      if (partial < 0) {
        item.PartialAmount = 0;
      }
    },
    
    calculateBalance(item) {
      const pendiente = parseFloat(item.pendiente_pago || 0);
      const partial = parseFloat(item.PartialAmount || pendiente);
      return pendiente - partial;
    },
    
    getBalanceClass(item) {
      const balance = this.calculateBalance(item);
      if (balance === 0) return 'success--text';
      if (balance > 0) return 'orange--text';
      return '';
    },
    
    getTotalOriginal() {
      return this.selectedPayments.reduce((sum, p) => sum + parseFloat(p.pendiente_pago || 0), 0);
    },
    
    getTotalPartial() {
      return this.selectedPayments.reduce((sum, p) => {
        const partial = parseFloat(p.PartialAmount);
        return sum + (isNaN(partial) ? parseFloat(p.pendiente_pago || 0) : partial);
      }, 0);
    },
    
    getTotalBalance() {
      return this.getTotalOriginal() - this.getTotalPartial();
    },
    
    async loadPayments() {
      this.loading = true;
      this.searched = true;
      try {
        const previousSelections = this.isEditMode ? [...this.selectedPayments] : [];
        const previousSelectionMap = new Map(
          previousSelections.map(payment => [this.getPaymentKey(payment), payment])
        );

        const response = await this.$API.paymenttemplate.getExpensesForTemplate({
          startDate: this.filters.startDate,
          endDate: this.filters.endDate,
          status: this.filters.invoiceStatus,
          invoiceType: this.filters.invoiceType
        });
        
        // Inicializar PartialAmount con el pendiente de pago
        this.payments = response.map(payment => {
          const key = this.getPaymentKey(payment);
          const existingSelection = previousSelectionMap.get(key);
          const partialAmount = existingSelection && existingSelection.PartialAmount !== null && existingSelection.PartialAmount !== undefined && existingSelection.PartialAmount !== ''
            ? parseFloat(existingSelection.PartialAmount)
            : parseFloat(payment.pendiente_pago || 0);

          return {
            ...payment,
            PartialAmount: partialAmount,
            ID_PaymentTemplateDetail: existingSelection?.ID_PaymentTemplateDetail || null,
            ID_Provider: existingSelection?.ID_Provider || payment.ID_Provider || payment.IDProviderOrCustomer || null,
            TypeProvider: existingSelection?.TypeProvider !== undefined && existingSelection?.TypeProvider !== null
              ? Number(existingSelection.TypeProvider)
              : (payment.TypeProvider !== undefined && payment.TypeProvider !== null ? Number(payment.TypeProvider) : null),
            _persisted: Boolean(existingSelection?._persisted)
          };
        });

        if (this.isEditMode) {
          const loadedIds = new Set(this.payments.map(payment => this.getPaymentKey(payment)));
          const outsideFilter = previousSelections.filter(payment => !loadedIds.has(this.getPaymentKey(payment)));
          const selectedInLoaded = this.payments.filter(payment => previousSelectionMap.has(this.getPaymentKey(payment)));
          this.selectedPayments = this.dedupePaymentsByKey([...outsideFilter, ...selectedInLoaded]);
        } else {
          this.selectedPayments = [];
        }
        
        // Contar pagos válidos e inválidos
        const validPayments = this.payments.filter(p => this.isPaymentValid(p)).length;
        const invalidPayments = this.payments.length - validPayments;
        
        if (this.payments.length === 0) {
          // No mostrar alert, el v-alert estático en el template ya muestra el mensaje
        } else if (invalidPayments > 0) {
          this.showAlert(
            'warning', 
            'Atención', 
            `Se encontraron ${this.payments.length} pagos. ${invalidPayments} pago(s) no tienen datos completos del proveedor y no se pueden seleccionar.`
          );
        }
      } catch (error) {
        console.error('Error al cargar pagos:', error);
        this.showAlert('danger', 'Error', 'Error al cargar los pagos. Intente nuevamente.');
        this.payments = [];
      } finally {
        this.loading = false;
      }
    },
    
    isPaymentValid(payment) {
      // Verificar que el pago tenga los datos necesarios para la plantilla PNR
      // Campos requeridos: ProviderBank, ProviderBankAccount, ProviderLegalNIT, DocumentNumber
      const hasText = value => value !== null && value !== undefined && String(value).trim() !== '';
      const hasDocumentNumber = hasText(payment['NÚMERO DE DOCUMENTO']);
      const hasProviderBank = hasText(payment.ProviderBank);
      const hasProviderBankAccount = hasText(payment.ProviderBankAccount);
      const hasProviderNIT = hasText(payment.ProviderLegalNIT);
      const hasValidProviderNIT = hasProviderNIT && [9,14].includes((payment.ProviderLegalNIT).replace(/-/g, '').trim().length);

      if (payment._persisted) {
        return hasProviderBank && hasProviderBankAccount && hasDocumentNumber;
      }

      return hasProviderBank && hasProviderBankAccount && hasProviderNIT && hasValidProviderNIT && hasDocumentNumber;
    },
    
    getValidationMessage(payment) {
      const missingFields = [];
      const hasText = value => value !== null && value !== undefined && String(value).trim() !== '';
      
      if (!hasText(payment['NÚMERO DE DOCUMENTO'])) {
        missingFields.push('Número de Documento');
      }
      if (!hasText(payment.ProviderBank)) {
        missingFields.push('Código de Banco');
      }
      if (!hasText(payment.ProviderBankAccount)) {
        missingFields.push('Número de Cuenta');
      }
      if (!hasText(payment.ProviderLegalNIT)) {
        missingFields.push('NIT del Proveedor');
      } else if( ![9,14].includes((payment.ProviderLegalNIT).replace(/-/g, '').trim().length) ) {
        missingFields.push('NIT del Proveedor no es válido');
      }
      
      return `Faltan datos: ${missingFields.join(', ')}`;
    },
    
    getRowClass(item) {
      return !this.isPaymentValid(item) ? 'invalid-payment-row' : '';
    },
    
    toggleSelectAll(value) {
      if (value) {
        // Seleccionar solo los pagos válidos del filtro actual, preservando los ya seleccionados fuera del filtro
        const filteredValidIds = new Set(this.validPayments.map(p => this.getPaymentKey(p)));
        const outsideFilter = this.selectedPayments.filter(p => !filteredValidIds.has(this.getPaymentKey(p)));
        this.selectedPayments = this.dedupePaymentsByKey([...outsideFilter, ...this.validPayments]);
      } else {
        // Deseleccionar solo los que están en el filtro actual, mantener los demás
        const filteredIds = new Set(this.filteredPayments.map(p => this.getPaymentKey(p)));
        this.selectedPayments = this.selectedPayments.filter(p => !filteredIds.has(this.getPaymentKey(p)));
      }
    },

    removeSelectedPayment(item) {
      if (this.isEditMode && item.ID_PaymentTemplateDetail) {
        const detailId = String(item.ID_PaymentTemplateDetail);
        if (!this.deletedDetailIds.map(id => String(id)).includes(detailId)) {
          this.deletedDetailIds.push(detailId);
        }
      }

      this.selectedPayments = this.selectedPayments.filter(
        payment => this.getPaymentKey(payment) !== this.getPaymentKey(item)
      );
    },
    
    async createTemplate() {
      if (this.selectedPayments.length === 0) {
        this.showAlert('warning', 'Advertencia', 'Debe seleccionar al menos un pago válido');
        return;
      }

      const invalidSelectedPayments = this.selectedPayments.filter(payment => !this.isPaymentValid(payment));
      if (invalidSelectedPayments.length > 0) {
        this.showAlert(
          'warning',
          'Datos incompletos',
          'Existen pagos seleccionados con datos incompletos del proveedor. Complete el banco y la cuenta bancaria antes de guardar la plantilla.'
        );
        return;
      }
      
      // Validar que exista número de plan
      if (!this.planNumber) {
        this.showAlert('warning', 'Número de Plan Requerido', `Debe configurar el número de plan antes de ${this.isEditMode ? 'actualizar' : 'crear'} una plantilla. Haga clic en "Configurar Número de Plan".`);
        return;
      }

      // Validar número de envío
      if (!this.sendNumber || this.sendNumber.trim() === '') {
        this.showAlert('warning', 'Advertencia', 'El número de envío es requerido');
        return;
      }

      if (!/^\d{5}$/.test(this.sendNumber)) {
        this.showAlert('warning', 'Advertencia', 'El número de envío debe tener exactamente 5 dígitos');
        return;
      }

      this.saving = true;
      try {
        // Preparar los datos con los montos parciales
        const paymentsWithPartialAmounts = this.selectedPayments.map(payment => ({
          ...payment,
          PartialAmount: payment.PartialAmount !== null && payment.PartialAmount !== undefined && payment.PartialAmount !== ''
            ? parseFloat(payment.PartialAmount)
            : parseFloat(payment.pendiente_pago || 0)
        }));
        const uniquePayments = this.dedupePaymentsByKey(paymentsWithPartialAmounts);
        
        const templateData = {
          name: this.templateName || null,
          description: this.templateDescription || null,
          templateDate: this.templateDate,
          sendNumber: this.sendNumber,
          payments: uniquePayments,
          deletedDetailIds: this.deletedDetailIds
        };

        const response = this.isEditMode
          ? await this.$API.paymenttemplate.updateTemplate(this.editingTemplateId, templateData)
          : await this.$API.paymenttemplate.createTemplate(templateData);

        this.pendingTemplateAction = this.isEditMode ? 'edit' : 'create';
        this.showAlert(
          'successWithCallback',
          'Éxito',
          `${this.isEditMode ? 'Plantilla actualizada exitosamente.' : 'Plantilla creada exitosamente.'} Número de Plan: ${response.planNumber}`
        );
      } catch (error) {
        console.error('Error al guardar plantilla:', error);
        
        // Obtener el mensaje específico del error
        let errorMessage = `Error al ${this.isEditMode ? 'actualizar' : 'crear'} la plantilla. Intente nuevamente.`;
        
        if (error.response && error.response.data) {
          const { message, error: errorDetail } = error.response.data;
          
          // Verificar si es un error de número de envío duplicado
          if (errorDetail && (errorDetail.includes('unique_send_number') || errorDetail.includes('Duplicate entry'))) {
            errorMessage = `El número de envío ${this.sendNumber} ya existe. Por favor, use otro número.`;
          } else if (message) {
            errorMessage = message;
          }
        }
        
        this.showAlert('danger', 'Error', errorMessage);
      } finally {
        this.saving = false;
      }
    },
    
    resetForm() {
      const today = new Date();
      this.isEditMode = false;
      this.editingTemplateId = null;
      this.deletedDetailIds = [];
      this.pendingTemplateAction = null;
      this.closeProviderBankEditDialog();
      this.templateName = this.generateDefaultTemplateName(today);
      this.templateDescription = '';
      this.templateDate = today.toISOString().split('T')[0];
      this.selectedPayments = [];
      this.payments = [];
      this.providerFilter = '';
      this.searched = false;
      this.currentStep = 1;
      // Recargar el siguiente número de envío
      this.loadNextSendNumber();
    },

    cancelEdit() {
      if (!this.isEditMode) {
        return;
      }

      this.resetForm();
      this.$emit('cancel-edit');
    },
    
    formatDate(date) {
      if (!date) return '';
      const d = new Date(date);
      return d.toLocaleDateString('es-ES', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      });
    },
    
    getDocumentColor(type) {
      const colors = {
        'FNS': 'blue',
        'PNR': 'green',
        'CCF': 'orange',
        'FAC': 'purple',
        'DCL': 'red'
      };
      return colors[type] || 'grey';
    }
  }
};
</script>

<style scoped>
.v-data-table {
  font-size: 0.875rem;
}

/* Sombrear en rojo las filas de pagos con datos incompletos */
::v-deep .invalid-payment-row {
  background-color: #ffebee !important;
}

::v-deep .invalid-payment-row:hover {
  background-color: #ffcdd2 !important;
}

/* Asegurar que el checkbox y el contenido sean visibles sobre el fondo rojo */
::v-deep .invalid-payment-row td {
  color: rgba(0, 0, 0, 0.87) !important;
}

/* Estilo para checkboxes deshabilitados */
::v-deep .invalid-payment-row .v-simple-checkbox {
  opacity: 0.4;
  cursor: not-allowed !important;
}

/* Estilos para campos de monto parcial */
::v-deep .v-text-field--outlined {
  border-radius: 4px;
}

::v-deep .v-text-field input {
  text-align: left;
}

/* Mejorar visualización de los totales */
.text-h6 {
  font-weight: 600;
}

.text-subtitle-2 {
  text-transform: uppercase;
  font-size: 0.75rem;
  letter-spacing: 0.5px;
}

/* Indicador de pasos */
.step-indicator {
  transition: color 0.3s ease;
}
</style>
